<template>
  <div
    class="home-container"
    :style="{
      backgroundImage: 'url(' + require('@/assets/images/home.png') + ')',
    }"
  >
    <div class="home-text-container">
      <img width="325" :src="require('@/assets/images/logo_mask.png')" />
      <h1 class="home-text-title">{{ titles }}</h1>
      <p class="home-text-blurb">{{ blurb }}</p>
    </div>

    <div class="uk-container uk-container-large">
      <div class="home-language__button-container">
        <button @click="changeLocale('en')" class="home-language__button">English</button>
        <div class="spacer" />
        <button @click="changeLocale('zhcn')" class="home-language__button">简体</button>
      </div>
      <div class="spacer-vertical" />
      <div class="home-language__button-container">
        <button @click="changeLocale('fr')" class="home-language__button">Français</button>
        <div class="spacer" />
        <button @click="changeLocale('zhtw')" class="home-language__button">繁體</button>
      </div>
    </div>
  </div>
</template>

<script>
const titles = {
  en: "FIGHT COVID-19 RACISM",
  fr: "COMBATTRE LE RACISME LIÉ À LA COVID-19",
  zhcn: "反抗新型冠状病毒肺炎种族主义",
  zhtw: "反抗新型冠狀病毒肺炎種族主義"
};
const blurbs = {
  en:
    "Anti-Asian racism is on the rise across Canada. This platform aims to allow individuals to share their experiences of racism, and will allow us to track and record instances of Anti-Asian racism during COVID-19. You’ll also find resources and support that you can access. We’ll get through this together.",
  fr:
    "Le racisme anti-asiatique est en hausse partout au Canada. Cette plateforme permettra aux personnes de partager leurs expériences de racisme, et nous permettra de suivre et documenter les incidents racistes anti-asiatiques pendant la COVID-19. Vous y retrouverez aussi accès aux ressources et à l’appui. Ensemble, nous allons nous en sortir.",
  zhcn:
    "在整个加拿大，反亚裔种族主义正在上升。该平台旨在让个人分享他们被种族歧视的经历，并使我们能够在新型冠状病毒肺炎期间追踪和记录反亚实例。您还将找到可以访问的资源和支持。我们会一起度过难关。",
  zhtw:
    "在整個加拿大，反亞裔種族主義正在上升。該平台旨在讓個人分享他們被種族歧視的經歷，並使我們能夠在新型冠狀病毒肺炎期間追踪和記錄反亞實例。您還將找到可以訪問的資源和支持。我們會一起度過難關。"
};

export default {
  name: "Home",
  computed: {
    titles() {
      return titles[this.$i18n.locale];
    },
    blurb() {
      return blurbs[this.$i18n.locale];
    }
  },
  methods: {
    changeLocale(locale) {
      this.$i18n.locale = locale;
      this.$router.push({ path: "/report" });
    }
  }
};
</script>
<style scoped>
.home-container {
  display: flex;
  flex-direction: column;
  height: 100vh;
  padding-top: 20px;
}

.home-language__button-container {
  display: flex;
  justify-content: center;
  /* border: 3px solid black; */
}

.home-language__button {
  height: 50px;
  width: 150px;
  font-size: 16px;
  color: white;
  background-color: rgb(41, 41, 41);
  border-width: 0;
  border-radius: 25px;
  cursor: pointer;
  transition: 0.25s ease;
}

.home-language__button:hover {
  box-shadow: 0 6px 18px 0 rgba(#000, 0.1);
  transform: translateY(-3px);
}

.spacer {
  height: 100%;
  width: 40px;
}

.spacer-vertical {
  height: 25px;
  width: 100px;
}

.home-text-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.home-text-title {
  margin-top: 0;
  padding-top: 15px;
  margin-bottom: 0;
  text-align: center;
  color: white;
  font-size: 65px;
}

.home-text-blurb {
  font-size: 18px;
  text-align: center;
  color: white;
  width: 50%;
}

@media only screen and (max-width: 1000px) {
  .home-text-title {
    font-size: 36px;
  }
  .home-text-blurb {
    width: 80%;
  }
}

@media only screen and (max-width: 500px) {
  .home-text-title {
    font-size: 25px;
  }
  .home-text-blurb {
    width: 80%;
    font-size: 14px;
  }
}
</style>
